import './plugins/casl';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import './assets/styles/main.css';
import './assets/styles/notification.scss';
import 'vue-loading-overlay/dist/vue-loading.css';

import { ValidationObserver, ValidationProvider } from 'vee-validate';

import App from './App.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import InitialLayout from '@/layouts/InitialLayout.vue';
import Loading from 'vue-loading-overlay';
import Notifications from 'vue-notification';
import Vue from 'vue';
import VueTailwind from 'vue-tailwind';
import router from './router';
// Tailwind
import { settings } from './components/tailWindConfig';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.use(VueTailwind, settings);

Vue.use(Notifications);

Vue.component('initial-layout', InitialLayout);
Vue.component('default-layout', DefaultLayout);

// eslint-disable-next-line
Vue.component('Loading', Loading);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
